import { MapPin, Building2 } from "lucide-react";
import { EVENT } from "../data/eventData";
import { MaskLine, Reveal } from "./Motion";

export default function VenueSection() {
  return (
    <section id="local" className="relative py-20 sm:py-28 overflow-hidden" data-testid="venue-section">
      <div className="absolute inset-0 bg-[radial-gradient(900px_520px_at_20%_40%,rgba(0,200,255,0.10),transparent_65%)] pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
        <div className="mb-12 sm:mb-16">
          <h2 className="heading-lg max-w-4xl" data-testid="venue-heading">
            <MaskLine inView>Local do evento:</MaskLine>
            <MaskLine inView delay={0.12}>
              <span className="text-gradient-blue">a 100 metros da Praia dos Ingleses.</span>
            </MaskLine>
          </h2>
          <Reveal delay={0.2}>
            <p className="mt-5 text-white/60 text-sm sm:text-base max-w-2xl leading-relaxed">
              Três dias de imersão em um resort de convenções completo, a passos da areia. Aprendizado de alto nível
              com a energia do litoral de Florianópolis.
            </p>
          </Reveal>
        </div>

        <div className="grid lg:grid-cols-5 gap-5 sm:gap-6 items-stretch">
          {/* Centro de convenções · destaque maior */}
          <Reveal className="lg:col-span-3 h-full">
            <div className="relative h-full min-h-[320px] sm:min-h-[440px] rounded-3xl overflow-hidden border border-white/10 shadow-[0_40px_120px_rgba(0,20,60,0.5)] group" data-testid="venue-convention-card">
              <img
                src="/venue-convention.jpg"
                alt="Oceania Convention Center"
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/95 via-brand-deep/25 to-transparent" />
              <div className="absolute bottom-5 left-5 right-5">
                <p className="font-sans text-xs font-semibold text-brand-cyan mb-2">
                  Onde tudo acontece
                </p>
                <h3 className="font-display font-extrabold uppercase text-white text-xl sm:text-2xl leading-tight" data-testid="venue-name">
                  Oceania Convention Center
                </h3>
                <p className="mt-1.5 text-xs sm:text-sm text-brand-silver/80 flex items-center gap-1.5">
                  <MapPin size={13} className="text-brand-cyan shrink-0" />
                  Praia dos Ingleses · Florianópolis/SC
                </p>
              </div>
            </div>
          </Reveal>

          {/* Hotel + cartão de informações */}
          <div className="lg:col-span-2 flex flex-col gap-5 sm:gap-6">
            <Reveal delay={0.12}>
              <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-[0_24px_80px_rgba(0,20,60,0.45)] group" data-testid="venue-hotel-card">
                <div className="relative aspect-[16/9]">
                  <img
                    src="/venue-hotel.jpg"
                    alt="Oceania Park Hotel Spa"
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-deep/90 via-transparent to-transparent" />
                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="font-sans text-xs font-semibold text-brand-cyan mb-1">Hospedagem no complexo</p>
                    <h4 className="font-display font-bold text-white text-base sm:text-lg">Oceania Park Hotel Spa</h4>
                  </div>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.2} className="flex-1">
              <div className="h-full rounded-3xl glass-static ring-glow p-6 sm:p-7 flex flex-col justify-center" data-testid="venue-info-card">
                <span className="h-11 w-11 rounded-xl bg-white/[0.08] border border-white/15 flex items-center justify-center mb-4 shadow-[inset_0_1px_0_rgba(255,255,255,0.12)]">
                  <Building2 size={20} className="text-white/85" />
                </span>
                <h4 className="font-display font-extrabold uppercase text-white text-lg leading-tight">
                  {EVENT.venue}
                </h4>
                <p className="mt-2 text-sm text-brand-silver/75 leading-relaxed">
                  Estrutura completa de hotelaria e convenções à beira-mar, com plenárias, salas simultâneas e toda a
                  experiência do PS27 em um só lugar.
                </p>
                <p className="mt-4 font-display text-sm font-bold text-brand-cyan">
                  {EVENT.dateLabel}
                </p>
                <a
                  href="/guia-hospedagem-ps27.pdf"
                  download="Guia_Hospedagem_PS27.pdf"
                  className="btn-ghost w-full mt-5 !py-3 !text-xs"
                  data-testid="venue-hotels-btn"
                >
                  Baixar hotéis próximos ao evento
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
